// src/app/selectors/trainingSelectors.ts
import { createSelector } from "@reduxjs/toolkit";
import { IRootState } from "../app/store";
import { GetTdroomAllApiResponse, openapi } from "../../openapi";
import { IPixPolygon } from "../components/PixBimViewer/types";
import { DEVICES_TYPES_SETTINGS } from "../enums";

export const selectHttpTdroomAll = createSelector([(state: IRootState) => state], (state) => {
  return openapi.endpoints.getTdroomAll.select()(state).data as GetTdroomAllApiResponse;
});

const selectActiveTdRoomId = (state: IRootState) => state.training.activeTdRoomId;

export const selectHttpTdroomSingle = createSelector(
  [selectActiveTdRoomId, (state: IRootState) => state],
  (activeTdRoomId, state) => {
    if (!activeTdRoomId) return null;

    const args = { tdroomId: activeTdRoomId };
    return openapi.endpoints.getTdroomSingle.select(args)(state).data ?? null;
  }
);

export const selectTdroomPixPolygons = createSelector([selectHttpTdroomSingle], (tdroom) => {
  if (!tdroom) return null;

  const spacePixPolygon: IPixPolygon = {
    id: "1",
    points: tdroom.polygon as number[][],
    fillColor: "#ffffff",
    strokeColor: "#000",
    strokeWidth: "10",
    text: {
      values: [tdroom.roomNumber, tdroom.roomLongName ?? "-"],
      color: "#000000",
      fontSize: "50px",
      show: true,
    },
    isMoveable: false,
    tooltip: "",
    isDragSelectable: false,
  };

  const sortedDevices = [...(tdroom.devices ?? [])].sort((a, b) => {
    if (a.deviceCategory === "FURNITURE" && b.deviceCategory !== "FURNITURE") return -1;
    if (a.deviceCategory !== "FURNITURE" && b.deviceCategory === "FURNITURE") return 1;
    return 0;
  });

  const devicePolygons: IPixPolygon[] = sortedDevices.map((deviceItem) => {
    const color = DEVICES_TYPES_SETTINGS?.[deviceItem.deviceCategory]?.color || "#000000";
    return {
      id: String(deviceItem._id),
      points: deviceItem.boundingBox as number[][],
      fillColor: color,
      strokeColor: "cyan",
      strokeWidth: "0.05",
      text: {
        show: true,
        values: [],
        color: "black",
        fontSize: "1",
      },
      tooltip: undefined,
      isMoveable: false,
      isDragSelectable: false,
    };
  });

  return [spacePixPolygon, ...devicePolygons] as IPixPolygon[];
});
